"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureFlags = void 0;

var _useFeatureFlagsQuery2 = require("./useFeatureFlagsQuery");

var useFeatureFlags = function useFeatureFlags(input) {
  var _useFeatureFlagsQuery = (0, _useFeatureFlagsQuery2.useFeatureFlagsQuery)(input),
      featureFlags = _useFeatureFlagsQuery.featureFlags;

  return featureFlags || {};
};

exports.useFeatureFlags = useFeatureFlags;